import React from "react";
import {Box, Stack, Divider, Grid} from '@mui/material';
import DateRangeForm from "../../../common/DateRangeForm";
import useLocationQueryDateRange from "../../../hooks/useLocationQueryDateRange";
import moment from "moment";
import useGetCampaignsMetrics from "./hooks/useGetCampaignsMetrics";
import StatsItem from "../../AcquireDashboard/Utilities/StatsItem";
import {getYearRange} from "_helpers";

export default function PerformanceMetrics() {
    const yearCount = 2
    const { startDate, endDate, setDates } = useLocationQueryDateRange(
        { initialStartDate: moment().subtract(yearCount, 'years') }
    );
    const payload = {
        startDate: moment(startDate).startOf('day').toISOString(),
        endDate: moment(endDate).endOf('day').toISOString(),
    }
    const { data } = useGetCampaignsMetrics(payload)

    return(
        <Box mt={{ xs: '14px', sm: '20px', }}>
            <Stack
                sx={styles.root}
                direction={'column'}
                divider={<Divider orientation={'horizontal'} flexItem />}
            >
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} sx={styles.header}>
                    <Box component={'h2'} sx={styles.headerTitle}>
                        Performance Metrics
                    </Box>
                    <Stack direction={'row'} spacing={2} sx={{ width: { xs: '100%', sm: 'auto' } }}>
                        <DateRangeForm
                            startDate={startDate}
                            endDate={endDate}
                            setDates={setDates}
                            label={'Viewing metrics for'}
                            additionalRanges={[
                                getYearRange(yearCount)
                            ]}
                        />
                    </Stack>
                </Stack>

                <Grid container columns={4} spacing={3} sx={styles.gridStyle}>
                    <StatsItem
                        label={'Winback Revenue'}
                        entry={{ value: data?.winbackRevenue}}
                        descriptionChildren={<Box>Revenue After Retain AI Outreach</Box>}
                    />
                    <StatsItem
                        label={'Conversions'}
                        entry={{ value: data?.conversions, formatStyle: 'number' }}
                        descriptionChildren={<Box>Customers won back after Retain AI Outreach</Box>}
                    />
                    <StatsItem
                        label={'Additional Revenue'}
                        entry={{ value: data?.additionalRevenue}}
                        descriptionChildren={<Box>Revenue from subsequent orders after winback</Box>}
                    />
                    <StatsItem
                        label={'LTV Increase'}
                        entry={{ value: data?.ltvIncreaseRatio, formatStyle: 'percent' }}
                        descriptionChildren={<Box>Increase in LTV from customers won back</Box>}
                    />
                </Grid>
            </Stack>
        </Box>
    )
}

const styles = {
    root: {
        borderRadius: '10px',
        border: '1px solid #B6BEBF98',
        background: '#fff',
    },
    header: {
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 0 },
        minHeight: { xs: 'auto', md: '73px' },
        zIndex: 10, // MUI draws a big padding over the header, so we need to make sure the header is on top so it's still interactable.
    },
    headerTitle: {
        m: 0,
        fontFamily: 'FustatBold',
        fontSize: { xs: '14px', md: '19px' }
    },
    gridStyle: {
        position: 'relative',
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 3 }
    },
}